import { render, staticRenderFns } from "./Calling.vue?vue&type=template&id=752953b2&scoped=true&"
import script from "./Calling.vue?vue&type=script&lang=js&"
export * from "./Calling.vue?vue&type=script&lang=js&"
import style0 from "./Calling.vue?vue&type=style&index=0&id=752953b2&lang=less&scoped=true&"
import style1 from "./Calling.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752953b2",
  null
  
)

export default component.exports